import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { addPromotionCodeById } from '@nike/ux-tread-cart';
import { SERVICE_ADD_PROMOTION } from '@nike/cart-constants';
import { DOTCOM_UX_ID, NIKE_BRAND, NIKECOM_CHANNEL } from '@nike/ux-tread-dotcom-constants';
import handleCartErrors from './handle-cart-errors';
import { onFetchStart, onFetchSuccess } from './action-creators';

/**
 * removeCartItem allows you to remove a single cart item with a given id
 *
 * @param {object} params - named parameters
 * @param {string} params.appId - app specific id used with unite config
 * @param {string} params.brand - brand
 * @param {string} params.channel - channel
 * @param {string} params.cloudStack - cloud_stack header to pass along to ux-tread-cart
 * @param {string} params.country - country code
 * @param {string} params.token - unite authToken
 * @param {string} params.visitId - unite session visit id
 * @param {string} params.visitorId - unite session visitor id
 * @param {string} params.promotionCode - promocode to add to cart
 * @param {string} params.host - host name to use when calling carts service
 * @returns {Promise} fetch promise
 */
export default function addPromotionCode(_ref) {
  var _ref$appId = _ref.appId,
    appId = _ref$appId === void 0 ? DOTCOM_UX_ID : _ref$appId,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? NIKE_BRAND : _ref$brand,
    _ref$channel = _ref.channel,
    channel = _ref$channel === void 0 ? NIKECOM_CHANNEL : _ref$channel,
    country = _ref.country,
    token = _ref.token,
    promotionCode = _ref.promotionCode,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    cloudStack = _ref.cloudStack,
    host = _ref.host;
  return function (dispatch) {
    var params = {
      cloudStack: cloudStack,
      token: token,
      visitId: visitId,
      visitorId: visitorId,
      appId: appId,
      brand: brand,
      channel: channel,
      country: country,
      host: host,
      // 'items' are action entities, not 'cart' items.  Contains the data
      // used in the patch within patch-carts-by-params.js
      items: [promotionCode]
    };
    var service = SERVICE_ADD_PROMOTION;
    dispatch(onFetchStart(_objectSpread({
      service: service
    }, params)));
    return addPromotionCodeById(params).then(function (payload) {
      return dispatch(onFetchSuccess(_objectSpread({
        service: service
      }, payload)));
    }, function (error) {
      return dispatch(handleCartErrors({
        service: service,
        params: params,
        error: error
      }));
    });
  };
}